import { render, staticRenderFns } from "./DeviceInfoGeneral.vue?vue&type=template&id=60675f0a&scoped=true"
import script from "./DeviceInfoGeneral.vue?vue&type=script&lang=js"
export * from "./DeviceInfoGeneral.vue?vue&type=script&lang=js"
import style0 from "./DeviceInfoGeneral.vue?vue&type=style&index=0&id=60675f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60675f0a",
  null
  
)

export default component.exports